<!-- src\app\page\applications-page\applications-page.component.html -->

  <app-table #applicationTable class="application-table" [construct]="construct"></app-table>
